"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pause = void 0;
async function pause(milliseconds) {
    return new Promise(resolve => setTimeout(resolve, milliseconds));
}
exports.pause = pause;
